import { setRMF10Auth } from "@/plugins/http";

// 获取 f10 token
// export async function getF10Auth() {
//   const { url, name, id, ttl, key, secret } = api.f10auth
//
//   const res = await get(`${url}?name=${name}&id=${id}&ttl=${ttl}&key=${key}&secret=${secret}`)
//
//   setF10Auth(res)
// }

// async function getSDKAuth() {
//   // let auth = localStorage.getItem('SDK_AUTH')
//   // if (auth) {
//   //   const { token, expiresIn } = JSON.parse(auth)
//   //   if (expiresIn - Date.now() > 0) {
//   //     setSDKAuth(token)
//   //     return
//   //   }
//   // }
//
//   const { url, appId, secret, expiresIn } = api.sdkauth
//
//   const res = await post(url, { appId, secret, expiresIn })
//
//   const { appid: resappid, accessToken } = res?.body ?? {}
//   const token = `v2&${resappid}&${accessToken}`
//   setSDKAuth(token)
//
//   /*
//   ! f10 的鉴权待优化
//   ! code !== 200 时，code 为多少，以及响应消息体是咋样的
//
//   if (res.code === '200') {
//     // const { appId, accessToken, expiresIn } = res?.body ?? {}
//     const { appid: resappid, accessToken } = res?.body ?? {}
//     const token = `v2&${resappid}&${accessToken}`
//     // localStorage.setItem('SDK_AUTH', JSON.stringify({ token, expiresIn }))
//     setSDKAuth(token)
//   } else {
//     // alert('没有SDK权限!')
//   }
//   */
// }

function getBasicAuth() {
  const tokenRegex = /token=([^&]+)/
  const match = window.location.href.match(tokenRegex)
  const token = match ? match[1] : null
  if (token) {
    localStorage.setItem('token', token)
    setRMF10Auth(token)
  } else if (localStorage.getItem('token')) {
    setRMF10Auth(localStorage.getItem('token'))
  }
}

export default async (vm) => {
  // await getF10Auth()
  // await getSDKAuth()
  getBasicAuth()
  vm && vm.$mount('#app')
}
